import "./TextInput.css";

export type TextInputProps = {
  title: string;
  value: string;
  setValue: (value: string) => void;
  handleSubmit?: () => void;
  placeholder: string;
  disabled?: boolean;
  onFocus?: () => void;
  onClick?: () => void;
  inputRef?: React.RefObject<HTMLInputElement>;
};

const TextInput = ({
  title,
  value,
  setValue,
  handleSubmit,
  placeholder,
  disabled,
  onFocus,
  onClick,
  inputRef,
}: TextInputProps) => {
  return (
    <input
      ref={inputRef}
      title={title}
      type="text"
      className="winslow-text-input"
      placeholder={placeholder}
      value={value || ""}
      disabled={disabled}
      onChange={(e) => setValue(e.target.value)}
      onFocus={onFocus}
      onClick={onClick}
      onKeyDown={(e: any) => {
        if (e.key === "Enter") {
          if (handleSubmit) {
            handleSubmit();
          }
        }
      }}
    />
  );
};

export default TextInput;
